import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";
import { fetchNews } from "@/lib/api";
import { NewsCard } from "@/components/news/NewsCard";
import { GridSkeleton } from "@/components/news/Skeletons";

const SUGGESTIONS = ["Maputo", "Economia", "Cabo Delgado", "Saúde", "Futebol", "Governo"];

export default function SearchPage() {
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    document.title = "Pesquisar | Notícia 365";
    const t = setTimeout(async () => {
      if (q.trim().length < 2) { setItems([]); return; }
      setLoading(true);
      try { setItems((await fetchNews({ q: q.trim(), limit: 30 })).items); } finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
      <h1 className="font-serif-display text-4xl font-black sm:text-5xl">Pesquisar</h1>
      <div className="relative mt-6">
        <Search className="absolute left-5 top-1/2 -translate-y-1/2 text-muted-foreground" size={20} />
        <input data-testid="search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Procure por temas, lugares, pessoas…"
          className="h-14 w-full rounded-full border-2 bg-card pl-14 pr-12 text-base outline-none transition-colors focus:border-primary" />
        {q && <button data-testid="search-clear-btn" onClick={() => setQ("")} className="absolute right-5 top-1/2 -translate-y-1/2 text-muted-foreground"><X size={18} /></button>}
      </div>
      {!q && (
        <div className="mt-5 flex flex-wrap gap-2">
          {SUGGESTIONS.map((s) => <button key={s} data-testid={`search-suggestion-${s.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setQ(s)} className="rounded-full bg-muted px-4 py-2 text-sm font-semibold hover:bg-primary hover:text-white">{s}</button>)}
        </div>
      )}
      <div className="mt-10">
        {loading ? <GridSkeleton /> : q.trim().length >= 2 && (
          <>
            <p data-testid="search-results-count" className="mb-6 font-mono-meta text-xs uppercase tracking-widest text-muted-foreground">{items.length} resultados para “{q}”</p>
            <div className="grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">{items.map((a, i) => <NewsCard key={a.id} a={a} i={i} />)}</div>
          </>
        )}
      </div>
    </div>
  );
}
